import {
  Box,
  Button,
  Image,
  Text,
  Flex,
  Heading,
  VStack,
  useBreakpointValue,
  Icon,
  Input,
} from "@chakra-ui/react";
import { FaIceCream, FaPizzaSlice } from "react-icons/fa";

const MobileScreen = ({
    categoryBackgroundColor,
    categoryBorderColor,
    categorySelectedBorderColor,
    categoryBorderWidth,
    categoryTitleColor,
    categorySelectedBorderWidth,
    
    kioskCategorySelectionColor,
    kioskCategoryBackgroundColor,
    kioskCategoryForegroundColor,
    
    itemCardBackgroundColor,
    itemCardBorderColor,
    itemCardBorderWidth,
    itemCardBorderRadius,
    itemNameTextColor,
    itemNameFontSize,
    itemDescriptionTextColor,
    itemDescriptionFontSize,
    itemPriceTextColor,
    itemPriceFontSize,
    itemImageWidth,
    itemImageHeight,
    itemImageBorderRadius,
    soldOutBackgroundColor,
    soldOutTextColor,
    soldOutFontSize,
    soldOutText,
    
    viewCartButtonBackgroundColor,
    viewCartButtonTextColor,
    viewCartButtonFontSize,
    viewCartButtonPadding,
    viewCartButtonBorderRadius,
    viewCartButtonShadowColor,
}) => {
  const cardWidth = useBreakpointValue({
    base: "100%",
    sm: "100%",
    md: "100%",
  });
  const cardHeight = useBreakpointValue({
    base: "auto",
    sm: "100px",
    md: "100px",
  }); // Set a fixed height for medium screens

  return (
    <Box
      display={"flex"}
      alignSelf={"center"}
      flexDirection={"column"}
      width={"100%"}
      height={"600px"}
      bg="white"
      p={2}
      border={"2px solid"}
      borderColor="gray.300"
      borderRadius="md"
    >
      <Flex justify="space-between" align="center" mb={2}>
        <Input
          placeholder="Search..."
          size="md"
          bg="white"
          border={"3px solid #F0F0F0"}
          borderRadius="md"
          px={4}
        />
      </Flex>
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={2}
        justify="space-between"
        mb={4}
      >
        <CustomCard
          icon={FaPizzaSlice}
          title="CREATE YOUR OWN"
          subtitle="PIZZA"
          description="ELIO'S"
          color="red.600"
          categoryBackgroundColor={categoryBackgroundColor}
          categoryBorderColor={categoryBorderColor}
          categorySelectedBorderColor={categorySelectedBorderColor}
          categoryBorderWidth={categoryBorderWidth}
          categorySelectedBorderWidth={categorySelectedBorderWidth}
          categoryTitleColor={categoryTitleColor}
        />

        <CustomCard
          icon={FaIceCream}
          title="CREATE YOUR OWN"
          subtitle="ICE CREAM"
          description="PAPA'S PASTA"
          color="pink.400"
          categoryBackgroundColor={categoryBackgroundColor}
          categoryBorderColor={categoryBorderColor}
          categorySelectedBorderColor={""}
          categoryBorderWidth={categoryBorderWidth}
        />
      </Flex>

      <Box mb={2}>
        <Heading size="xs" mb={2}>
          PAPA'S PASTA
        </Heading>
        <VStack spacing={3} a2ign="stretch">
          <Box
            display={"flex"}
            flexDirection={"row"}
            bg={itemCardBackgroundColor}
            p={1}
            borderRadius={itemCardBorderRadius}
            shadow="md"
            borderColor={itemCardBorderColor}
            borderWidth={itemCardBorderWidth}
            textAlign="start"
            w={cardWidth}
            h={cardHeight}
            mb={1}
          >
            <Image
              src="https://picsum.photos/id/1/200/300"
              alt="Colombian Coffee"
              maxH="100px"
              width={itemImageWidth}
              height={itemImageHeight}
              objectFit="cover"
              borderRadius={4}
            />
            <Flex flexDirection={"column"} ml={2}>
              <Text fontSize={itemNameFontSize} fontWeight="bold" mt={1} color={itemNameTextColor}>
                <Icon as={FaPizzaSlice} color="orange.400" w={3} h={3} mr={1} />
                Colombian Coffee
              </Text>
              <Text fontSize={itemDescriptionFontSize} fontWeight="bold" mt={1} color={itemDescriptionTextColor}>
                Homemade colombian coffee bean ice cream.
              </Text>
              <Text fontSize={itemPriceFontSize} fontWeight="bold" mt={1} color={itemPriceTextColor}>
                $4.95
              </Text>
            </Flex>
          </Box>
        </VStack>
      </Box>

      <Box mb={2}>
        <Heading size="xs" mb={2}>
          ELIO'S
        </Heading>
        <VStack spacing={3} align="stretch">
          {/* Each card now takes full width, with limited height and an image size adjustment */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            bg={itemCardBackgroundColor}
            p={1}
            borderRadius={itemCardBorderRadius}
            shadow="md"
            borderColor={itemCardBorderColor}
            borderWidth={itemCardBorderWidth}
            textAlign="start"
            w={cardWidth}
            h={cardHeight}
            mb={1}
          >
            <Image
              src="https://picsum.photos/id/1/200/300"
              alt="Colombian Coffee"
              maxH="100px"
              width={itemImageWidth}
              height={itemImageHeight}
              objectFit="cover"
              borderRadius={4}
            />
            <Flex flexDirection={"column"} ml={2}>
              <Text fontSize={itemNameFontSize} fontWeight="bold" mt={1} color={itemNameTextColor}>
                <Icon as={FaPizzaSlice} color="orange.400" w={3} h={3} mr={1} />
                Colombian Coffee
              </Text>
              <Text fontSize={itemDescriptionFontSize} fontWeight="bold" mt={1} color={itemDescriptionTextColor}>
                Homemade colombian coffee bean ice cream.
              </Text>
              <Text fontSize={itemPriceFontSize} fontWeight="bold" mt={1} color={itemPriceTextColor}>
                $4.95
              </Text>
            </Flex>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"row"}
            bg={itemCardBackgroundColor}
            p={1}
            borderRadius={itemCardBorderRadius}
            shadow="md"
            borderColor={itemCardBorderColor}
            borderWidth={itemCardBorderWidth}
            textAlign="start"
            w={cardWidth}
            h={cardHeight}
            mb={1}
          >
            <Image
              src="https://picsum.photos/id/1/200/300"
              alt="Colombian Coffee"
              maxH="100px"
              width={itemImageWidth}
              height={itemImageHeight}
              objectFit="cover"
              borderRadius={4}
            />
            <Flex flexDirection={"column"} ml={2}>
              <Text fontSize={itemNameFontSize} fontWeight="bold" mt={1} color={itemNameTextColor}>
                <Icon as={FaPizzaSlice} color="orange.400" w={3} h={3} mr={1} />
                Colombian Coffee
              </Text>
              <Text fontSize={itemDescriptionFontSize} fontWeight="bold" mt={1} color={itemDescriptionTextColor}>
                Homemade colombian coffee bean ice cream.
              </Text>
              <Text fontSize={itemPriceFontSize} fontWeight="bold" mt={1} color={itemPriceTextColor}>
                $4.95
              </Text>
            </Flex>
          </Box>
        </VStack>
      </Box>

      <Button
        bg={viewCartButtonBackgroundColor}
        color={viewCartButtonTextColor}
        fontSize={viewCartButtonFontSize}
        _hover={{ bg: "green.600" }}
        w="full"
        mt={1}
        minH={6}
      >
        VIEW CART
      </Button>
    </Box>
  );
};

export default MobileScreen;

const CustomCard = ({
  icon,
  title,
  subtitle,
  description,
  color = "red.500",
  categoryBackgroundColor,
  categoryBorderColor,
  categorySelectedBorderColor,
  categoryBorderWidth,
  categoryTitleColor,
  categorySelectedBorderWidth,
}) => {
  return (
    <Box
      bg={categoryBackgroundColor}
      borderRadius="md"
      shadow="lg"
      pt={1}
      border={`${categorySelectedBorderWidth || categoryBorderWidth}px solid ${categorySelectedBorderColor || categoryBorderColor}`}
      width={{ base: "100%", sm: "50%" }}
      textAlign="center"
    >
      {/* Flex for Logo and Title */}
      <Flex
        bg={color}
        flexDirection={"column"}
        justify="center"
        align="center"
        p={2}
      >
        <Icon as={icon} color="white" w={4} h={4} />
        <Text fontSize="xs" fontWeight="bold" color={categoryTitleColor}>
          {title}
        </Text>
        <Text fontSize="xs" fontWeight="bold" color="white">
          {subtitle}
        </Text>
      </Flex>

      {/* Subtext */}
      <Box py={1} borderRadius="md">
        <Text fontSize="xs" color="gray.700" fontWeight="bold">
          {description}
        </Text>
      </Box>
    </Box>
  );
};
